module.exports = __webpack_public_path__ + "static/media/arrow-down.2daa863b.svg";